import { generateInteractionProps } from "@/utils/generate-smart-toilets-interactions"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

export const handleCTAForFeatureCards = title => {
  const interactionData = generateInteractionProps(`${title}`, {
    internalLinkName: title,
    internalLinkPosition: `pxp:shop smart toilets`,
    internalLinkType: `pxp:${title}`,
    internalLinkZoneName: `pxp:shop smart toilets:${title}`,
  })

  pushAnalyticsObjToDataLayer({ ...interactionData })
}
